import { render } from "./add-videos-modal-bunkai.vue?vue&type=template&id=a58f211a"
import script from "./add-videos-modal-bunkai.vue?vue&type=script&lang=js"
export * from "./add-videos-modal-bunkai.vue?vue&type=script&lang=js"
script.render = render

export default script